import { __read } from 'tslib';
import { useState, useEffect } from 'react';

/**
 * This approach is being used to avoid rehydration error on latest versions of next/cypress
 * https://nextjs.org/docs/messages/react-hydration-error
 * @returns {isRendered: boolean}
 */
var useRenderControl = function () {
    var _a = __read(useState(false), 2), isRendered = _a[0], setIsRendered = _a[1];
    useEffect(function () {
        setIsRendered(true);
    }, []);
    return { isRendered: isRendered };
};

export { useRenderControl };
//# sourceMappingURL=useRenderControl.esm.js.map
